import { render, staticRenderFns } from "./TuxhornEThermP9Plus_1d03_P60.vue?vue&type=template&id=2d764d38&"
import script from "./TuxhornEThermP9Plus_1d03_P60.vue?vue&type=script&lang=js&"
export * from "./TuxhornEThermP9Plus_1d03_P60.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports